// Kitchen / notification sound presets.
// Web Audio API tabanlı synthesizer — dosya bağımlılığı yok.
// localStorage:
//   restaflex_sound_preset → 'beep' | 'chime' | 'bell'
//   restaflex_sound_volume → '0' .. '100' (string)

export const SOUND_PRESETS = ['beep', 'chime', 'bell'];
export const DEFAULT_PRESET = 'beep';
export const DEFAULT_VOLUME = 60;

export function getSoundPreset() {
  const v = localStorage.getItem('restaflex_sound_preset');
  return SOUND_PRESETS.includes(v) ? v : DEFAULT_PRESET;
}

export function setSoundPreset(preset) {
  if (SOUND_PRESETS.includes(preset)) {
    localStorage.setItem('restaflex_sound_preset', preset);
  }
}

export function getSoundVolume() {
  const raw = parseInt(localStorage.getItem('restaflex_sound_volume') || '', 10);
  if (Number.isFinite(raw) && raw >= 0 && raw <= 100) return raw;
  return DEFAULT_VOLUME;
}

export function setSoundVolume(vol) {
  const v = Math.max(0, Math.min(100, parseInt(vol, 10) || 0));
  localStorage.setItem('restaflex_sound_volume', String(v));
}

// preset definitions: array of tones [{freq, duration, delay}]
const PATTERNS = {
  beep:  [{ freq: 880,  duration: 0.35, delay: 0 }],
  chime: [
    { freq: 880,  duration: 0.18, delay: 0 },
    { freq: 1320, duration: 0.30, delay: 0.20 },
  ],
  bell:  [
    { freq: 1760, duration: 0.18, delay: 0 },
    { freq: 1320, duration: 0.18, delay: 0.16 },
    { freq: 880,  duration: 0.30, delay: 0.32 },
  ],
};

// playKitchenSound — schedules tones on a single AudioContext.
// preset: 'beep' | 'chime' | 'bell' (defaults to stored preference)
// volume: 0..100 (defaults to stored preference)
// Silently no-ops on autoplay-policy errors.
export function playKitchenSound(preset, volume) {
  try {
    const p = preset || getSoundPreset();
    const vol = (typeof volume === 'number' ? volume : getSoundVolume()) / 100;
    if (vol <= 0) return;
    const pattern = PATTERNS[p] || PATTERNS[DEFAULT_PRESET];
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const t0 = ctx.currentTime;
    pattern.forEach(({ freq, duration, delay }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.frequency.value = freq;
      osc.connect(gain);
      gain.connect(ctx.destination);
      const start = t0 + delay;
      gain.gain.setValueAtTime(0.25 * vol, start);
      gain.gain.exponentialRampToValueAtTime(0.001, start + duration);
      osc.start(start);
      osc.stop(start + duration);
    });
  } catch { /* autoplay engeli vs. — sessiz geç */ }
}
